import { Users, Heart, Activity, Stethoscope, Dumbbell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const audiences = [
  {
    icon: Users,
    title: "Seniors",
    description: "Safe, comfortable rides to medical appointments and wellness visits.",
  },
  {
    icon: Heart,
    title: "Assisted Living Residents",
    description: "Scheduled transportation for residents of assisted living and care facilities.",
  },
  {
    icon: Activity,
    title: "Dialysis Patients",
    description: "Reliable recurring rides to and from dialysis treatment centers.",
  },
  {
    icon: Stethoscope,
    title: "Surgery Patients",
    description: "Safe transport home after surgeries and outpatient procedures.",
  },
  {
    icon: Dumbbell,
    title: "Rehabilitation Patients",
    description: "Consistent rides to physical therapy and rehabilitation sessions.",
  },
];

const WhoWeServe = () => {
  return (
    <section className="py-14 sm:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-3 sm:mb-4">
            Who We Serve
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Compassionate transportation for patients who need reliable medical transport
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {audiences.map((item, index) => (
            <Card key={index} className="border-border rounded-2xl shadow-sm hover:shadow-md transition-all duration-300">
              <CardContent className="pt-5 sm:pt-6 pb-4 sm:pb-5 px-4 sm:px-6 flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <item.icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-foreground mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
